import fetch from "auth/FetchInterceptor";

const TestDirectoryService = {};

TestDirectoryService.fetch = function () {
  return fetch({
    url: "/labtest",
    method: "get",
  });
};

TestDirectoryService.fetchStatAndUrgentPrice = function () {
  return fetch({
    url: "/urgent_stat_price",
    method: "get",
  });
};

TestDirectoryService.updateStatAndUrgentPrice = function (data) {
  return fetch({
    url: "/urgent_stat_price",
    method: "post",
    data: data,
  });
};

TestDirectoryService.fetchTestAndPanel = function () {
  return fetch({
    url: "/testandpanel",
    method: "get",
  });
};

TestDirectoryService.create = function (data) {
  return fetch({
    url: "/labtest",
    method: "post",
    data,
  });
};

TestDirectoryService.update = function (data) {
  return fetch({
    url: "/labtest/" + data.id,
    method: "put",
    data,
  });
};

TestDirectoryService.delete = function (id) {
  return fetch({
    url: "/labtest/" + id,
    method: "delete",
  });
};

TestDirectoryService.upload = function (formData) {
  return fetch({
    url: "/uploadCsvTests",
    method: "post",
    data: formData,
  });
};

export default TestDirectoryService;
